var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticClass:"modal-backdrop1",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.close.apply(null, arguments)}}},[_c('div',{style:(_vm.styleObject),on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }